import { useContext } from "react";
import { SessionContext } from "../context/SessionContext";

/**
 * The signed-in session — see SessionContext for its shape.
 *
 *   const { user, kind, selectedHeadquarterId, logout } = useSession();
 */
export const useSession = () => {
  const session = useContext(SessionContext);

  if (!session) {
    throw new Error("useSession must be used inside <SessionProvider>.");
  }

  return session;
};
